import AnnUnifiedProfilePage from './AnnUnifiedProfilePage';

export default AnnUnifiedProfilePage;
